export function renderParagraph(text: string): string {
  if (!text) return '';
  // This REGEX replaces the last space with a non-breaking space character.
  // These ensures a paragraph does not a line with only a single word on it
  //
  // EXAMPLE:
  //  >IN:
  //  Hello this is a paragraph. It is
  //  long so it goes to the next line
  //  when it needs to. But the last
  //  word is wrapped awkwardly and
  //  then gets put on a new line itself
  //  isolated.
  //
  //  >OUT:
  //  Hello this is a paragraph. It is
  //  long so it goes to the next line
  //  when it needs to. But the last
  //  word is wrapped awkwardly and
  //  then gets put on a new line
  //  itself isolated.
  return text.replace(/\s+(?=\S*$)/gi, '\u00A0');
}
